var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    staticClass: "svg-icon",
    style: `width: ${_vm.size};height: ${_vm.size}`,
    attrs: {
      "aria-hidden": "true",
      "name": _vm.name
    }
  }, [_c('use', {
    ref: "useRef",
    attrs: {
      "xlink:href": _vm.symbolId,
      "fill": _vm.color
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };